import api from './api';
import { ApiResponse, PageResponse } from '../types';

export interface UserSearchResult {
  id: number;
  type: 'STUDENT' | 'TEACHER';
  typeDisplay: string;
  name: string;
  idCardNumber: string;
  genderDisplay?: string;
  schoolName?: string;
  className?: string;
  grade?: string;
  academicYear?: string;
  studentNumber?: string;
  employeeNumber?: string;
  department?: string;
  phone?: string;
  hasUserAccount: boolean;
  schoolId?: number;
}

export interface IndicatorInfo {
  name: string;
  score: number | null;
  conclusionTitle: string | null;
  level: string | null;
  crisisAlert: boolean;
}

export interface QuestionnaireRecord {
  questionnaireId: number;
  questionnaireCode: string | null;
  title: string;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED';
  submittedAt: string | null;
  hasCrisisAlert: boolean;
  indicators: IndicatorInfo[];
}

export interface EnrollmentInfo {
  schoolName: string;
  className: string;
  grade: string;
  academicYear: string;
  current: boolean;
}

export interface StudentDetail {
  id: number;
  name: string;
  idCardNumber: string;
  genderDisplay: string | null;
  phone: string | null;
  studentNumber: string | null;
  hasUserAccount: boolean;
  hasCrisisAlert: boolean;
  /** 当前就读学校是否允许显示学生敏感信息。后端默认 true。 */
  showStudentDetails: boolean;
  enrollments: EnrollmentInfo[];
  questionnaireHistory: QuestionnaireRecord[];
}

export const userSearchService = {
  search: async (params: {
    keyword: string;
    type?: 'ALL' | 'STUDENT' | 'TEACHER';
    page?: number;
    size?: number;
  }): Promise<PageResponse<UserSearchResult>> => {
    const response = await api.get<ApiResponse<PageResponse<UserSearchResult>>>('/admin/user-search', {
      params: {
        keyword: params.keyword,
        type: params.type || 'ALL',
        page: params.page || 0,
        size: params.size || 20,
      },
    });
    return response.data.data;
  },

  getStudentDetail: async (studentId: number): Promise<StudentDetail> => {
    const response = await api.get<ApiResponse<StudentDetail>>(`/admin/user-search/students/${studentId}/detail`);
    return response.data.data;
  },
};
